import { Network as NetworkComponent } from '@bridebook/web/app-basic/components/social-sharing/network.component';
import { getIsMobile, getIsTablet } from '@bridebook/web/app-basic/lib/app/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { FC, memo } from 'react';
import { NetworkProps } from './network.types';

const NetworkContainer: FC<NetworkProps> = ({ icon, iconWidth, color }) => {
  const isMobile = useSelector(getIsMobile);
  const isTablet = useSelector(getIsTablet);

  return (
    <NetworkComponent
      icon={icon}
      iconWidth={iconWidth}
      color={color}
      isMobile={isMobile}
      isTablet={isTablet}
    />
  );
};

export const Network = memo(NetworkContainer);
